import type {
	GetAutoflowByIdResponseJson,
	GetAutoflowsResponseJson,
	PatchAutoflowRequestInput,
	PatchAutoflowResponseJson,
	PostAutoflowPreviewRequest,
	PostAutoflowPreviewResponseJson,
	PostAutoflowRequest,
	PostAutoflowResponseJson,
} from "@performyard/service-contracts";

import internalRequest from "./internal-base-request";

export const getAutoflowPreview = async (
	data: PostAutoflowPreviewRequest
): Promise<PostAutoflowPreviewResponseJson> => {
	const [response] = await internalRequest<PostAutoflowPreviewResponseJson>("/v1/autoflow/preview", {
		method: "POST",
		body: JSON.stringify(data),
	});

	return response;
};

export const postAutoflow = async (data: PostAutoflowRequest): Promise<PostAutoflowResponseJson> => {
	const [response] = await internalRequest<PostAutoflowResponseJson>("/v1/autoflow", {
		method: "POST",
		body: JSON.stringify(data),
	});

	return response;
};

export const getAutoflows = async (): Promise<GetAutoflowsResponseJson> => {
	const [response] = await internalRequest<GetAutoflowsResponseJson>("/v1/autoflow", {
		method: "GET",
	});

	return response;
};

export const getAutoflowByResourceId = async (resourceId: string) => {
	const [data] = await internalRequest<GetAutoflowByIdResponseJson>(`/v1/autoflow/resource/${resourceId}`, {
		method: "GET",
	});
	return data as GetAutoflowByIdResponseJson;
};

export const patchAutoflow = async (
	id: string,
	data: PatchAutoflowRequestInput
): Promise<PatchAutoflowResponseJson> => {
	const [response] = await internalRequest<PatchAutoflowResponseJson>(`/v1/autoflow/${id}`, {
		method: "PATCH",
		body: JSON.stringify(data),
	});

	return response;
};
